import { FadeUp, SlideTitle, SlideConclusion } from "../Deck";

const OPTIONS = [
  {
    n: "01",
    h: "At-home care",
    p: "Our mainstay. A verified physiotherapist treats you at home.",
    chip: "Our mainstay",
  },
  {
    n: "02",
    h: "Remote care",
    p: "Guided sessions and follow-up, wherever you are.",
  },
  {
    n: "03",
    h: "Hybrid care",
    p: "Home visits and remote sessions combined in one plan.",
  },
  {
    n: "04",
    h: "Clinic and hospital",
    p: "In-person care at a facility when treatment calls for it.",
  },
];

const BG_IMG =
  "https://images.unsplash.com/photo-1723433892471-62f113c8c9a0?q=85&w=1920&auto=format&fit=crop";

export default function Slide06Patients() {
  return (
    <div className="relative">
      <div className="absolute inset-0" aria-hidden="true">
        <img src={BG_IMG} alt="" className="h-full w-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-r from-bone2 via-bone2/90 to-bone2/25" />
        <div className="absolute inset-0 bg-gradient-to-t from-bone2 via-transparent to-bone2/60" />
      </div>
      <div className="relative z-10 max-w-3xl">
        <SlideTitle>
          Recovery that <em className="italic text-gold">starts at home</em>
        </SlideTitle>
        <div className="mt-10 grid gap-5 sm:grid-cols-2">
          {OPTIONS.map((o, i) => (
            <FadeUp
              key={o.n}
              delay={0.1 + i * 0.08}
              className="h-full rounded-2xl border border-line bg-white/95 p-6 backdrop-blur-sm"
            >
              <div className="flex items-center justify-between">
                <span className="font-mono text-[11px] tracking-[0.2em] text-navy">
                  {o.n}
                </span>
                {o.chip && (
                  <span className="rounded-full bg-goldsoft px-3 py-1 font-mono text-[9px] uppercase tracking-[0.18em] text-ink">
                    {o.chip}
                  </span>
                )}
              </div>
              <h3 className="mt-4 text-lg font-semibold tracking-tight">
                {o.h}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-mut">{o.p}</p>
            </FadeUp>
          ))}
        </div>
        <SlideConclusion delay={0.45}>
          A verified physiotherapist. Your doctor always informed.
        </SlideConclusion>
      </div>
    </div>
  );
}
